window.addEventListener('load', () => {
  init();
})

const init = () => {
  const post_loop_blocks = document.querySelectorAll('[data-block-id="post-loop-block"]');
  if (post_loop_blocks) {
    post_loop_blocks.forEach(block => {
      const loop_filters = block.querySelectorAll('.js-loop-filter');
      const loop_load_more = block.querySelector('.js-load-more');
    
      let query_base_args = {
        post_type: block.dataset.postType,
        per_page: block.dataset.postsPerPage,
        status: 'publish',
        orderby: block.dataset.postsOrderby,
        order: block.dataset.postsOrder,
      }

      let category = block.dataset.currentCategory ? block.dataset.currentCategory : '';
      let new_page = block.dataset.currentPage ? block.dataset.currentPage : 1;
      block.dataset.currentPage = new_page;

      loadPosts(block, query_base_args, category, block.dataset.currentPage);

      if (loop_filters) {
        loop_filters.forEach(filter => {
          filter.addEventListener('click', e => {
            e.currentTarget.classList.toggle('active');
            e.currentTarget.classList.toggle('bg-bg_header');
            block.dataset.currentPage = 1;
            block.dataset.currentCategory = Array.from(block.querySelectorAll('.js-loop-filter.active')).map(cat => cat.dataset.termId).join(',');
            loadPosts(block, query_base_args, block.dataset.currentCategory, block.dataset.currentPage, true);
          })
        });
      }
      if (loop_load_more) {
          loop_load_more.addEventListener('click', e => {
            e.preventDefault();
            block.dataset.currentPage = +block.dataset.currentPage + 1
            loadPosts(block, query_base_args, block.dataset.currentCategory, block.dataset.currentPage);
          })
      }
    });
  }
}

const loadPosts = (block, query_base_args, category, new_page, reload_list = false) => {
  block.querySelector('.js-loader').style.display = 'block';
  if (block.querySelector('.js-load-more')) {
    block.querySelector('.js-load-more').style.display = 'none';
  }
  if (reload_list) {
    block.querySelector('.js-loop').innerHTML = '';
  }
  fetch(`${window.location.origin}/wp-json/api/filter-loop?post_type=${query_base_args.post_type}&per_page=${query_base_args.per_page}&page=${new_page}&status=${query_base_args.status}&orderby=${query_base_args.orderby}&order=${query_base_args.order}&categories=${category}`)
  .then(res => res.json())
  .then(body => {
    let response = JSON.parse(body);
    if (reload_list) {
      block.querySelector('.js-loop').innerHTML = response.content;
    } else {
      block.querySelector('.js-loop').innerHTML += response.content;
    }
    block.querySelector('.js-loader').style.display = 'none';
    let load_more = block.querySelector('.js-load-more');
    if (load_more) {
      if (!response.load_more) {
        load_more.style.display = 'none';
      } else {
        load_more.style.display = 'flex';
      }
    }
  })
}